import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import ProductCard from "./ProductCard";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

export default function UserPageProdSlider() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const API_BASE_URL = process.env.REACT_APP_BACKEND_URL;


  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/list-products`);
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        
        // Transform API data to match ProductCard structure
        const formattedProducts = data.products.map(product => {
          // Check if product has discounted prices
          const hasDiscount = product.discountedPrices && 
                             Object.keys(product.discountedPrices).length > 0;
          
          // Use 100ml price as default
          const basePrice = Number(product.prices["100ml"]);
          const discountedPrice = hasDiscount ? 
                                 Number(product.discountedPrices["100ml"]) : 
                                 basePrice;
          
          // Calculate discount percentage if there's a discount
          const discount = hasDiscount ? 
                         Math.round(((basePrice - discountedPrice) / basePrice) * 100) :
                         0;

          return {
            id: product.id,
            image: product.images[0], // Use the first image
            name: product.name,
            originalPrice: basePrice,
            discountedPrice: discountedPrice,
            discount: discount > 0 ? discount : null, // Only include if there's a discount
            isNewArrival: product.isNewArrival
          };
        });
        
        setProducts(formattedProducts);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  if (loading) {
    return <div className="text-center py-8">Loading products...</div>;
  }

  if (error) {
    return <div className="text-center py-8 text-red-500">Error: {error}</div>;
  }

  if (!products.length) {
    return <div className="text-center py-8">No products available</div>;
  }

  return (
    <div className="w-full px-5 md:px-8 py-2">
      <Swiper
        modules={[Pagination, Autoplay]}
        spaceBetween={30}
        slidesPerView={1}
        pagination={{
          clickable: true,
          renderBullet: (index, className) => {
            return `<span class="${className} w-2 h-2 bg-gray-400 rounded-full mx-1"></span>`;
          },
        }}
        autoplay={{
          delay: 4000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }}
        breakpoints={{
          480: { slidesPerView: 1, spaceBetween: 15 },
          768: { slidesPerView: 2, spaceBetween: 20 },
          1024: { slidesPerView: 3, spaceBetween: 25 },
          1280: { slidesPerView: 4, spaceBetween: 30 },
        }}
        className="product-swiper"
      >
        {products.map((product, index) => (
          <SwiperSlide key={index} className="py-4">
            <div className="transform transition-transform duration-300 hover:scale-105">
              <ProductCard product={product} />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
